import React from 'react';
import styled from 'styled-components';
import { IconButton } from 'components/Shared';
import { convertHexToRGBA } from 'utils/color';
import { ChevronLeft } from '@styled-icons/bootstrap/ChevronLeft';
import { ChevronRight } from '@styled-icons/bootstrap/ChevronRight';
import { media } from 'styled-bootstrap-grid';
const Arrow = styled(IconButton) `
  background-color: ${({ theme }) => convertHexToRGBA(theme.palette.grey[600], 0.8)};
  color: #fff;
  border: 0;
  border-radius: 50%;
  width: 38px;
  height: 38px;

  ${media.xs `
     display: none;
  `}
`;
const ButtonGroup = styled.div `
  position: absolute;
  width: 100%;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
  display: flex;
  justify-content: space-between;
`;
const ArrowButtonGroup = ({ next, previous, carouselState: { totalItems, slidesToShow }, }) => {
    if (totalItems < slidesToShow)
        return null;
    return (React.createElement(ButtonGroup, null,
        React.createElement(Arrow, { onClick: previous },
            React.createElement(ChevronLeft, { size: 20 })),
        React.createElement(Arrow, { onClick: next },
            React.createElement(ChevronRight, { size: 20 }))));
};
export default ArrowButtonGroup;
